import gql from 'graphql-tag';
import { VERTICAL_TYPE } from './VerticalType.gql';

export const ADD_VERTICAL = gql`
  ${VERTICAL_TYPE}
  mutation addVertical($employees: [Int], $verticalData: VerticalInput!) {
    createVertical(employees: $employees, verticalData: $verticalData) {
      vertical {
        ...VerticalType
      }
    }
  }
`;
